/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WebApiServicesDataTransferObjectsGroupServiceUpdateMemberResultDto
 */
export interface WebApiServicesDataTransferObjectsGroupServiceUpdateMemberResultDto {
    /**
     * 
     * @type {boolean}
     * @memberof WebApiServicesDataTransferObjectsGroupServiceUpdateMemberResultDto
     */
    success?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WebApiServicesDataTransferObjectsGroupServiceUpdateMemberResultDto
     */
    emailChangePending?: boolean;
}

/**
 * Check if a given object implements the WebApiServicesDataTransferObjectsGroupServiceUpdateMemberResultDto interface.
 */
export function instanceOfWebApiServicesDataTransferObjectsGroupServiceUpdateMemberResultDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiServicesDataTransferObjectsGroupServiceUpdateMemberResultDtoFromJSON(json: any): WebApiServicesDataTransferObjectsGroupServiceUpdateMemberResultDto {
    return WebApiServicesDataTransferObjectsGroupServiceUpdateMemberResultDtoFromJSONTyped(json, false);
}

export function WebApiServicesDataTransferObjectsGroupServiceUpdateMemberResultDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiServicesDataTransferObjectsGroupServiceUpdateMemberResultDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'success': !exists(json, 'success') ? undefined : json['success'],
        'emailChangePending': !exists(json, 'emailChangePending') ? undefined : json['emailChangePending'],
    };
}

export function WebApiServicesDataTransferObjectsGroupServiceUpdateMemberResultDtoToJSON(value?: WebApiServicesDataTransferObjectsGroupServiceUpdateMemberResultDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'success': value.success,
        'emailChangePending': value.emailChangePending,
    };
}

